import React from 'react';
import Layout from '../main/Layout/Layout';
import {isAuthenticated} from '../auth/authenticate';
import {Link} from 'react-router-dom';

function UserDashboard(props) {
    let _id,name,email,role;
    if(isAuthenticated().data)
    {
         _id = isAuthenticated().data.user._id; //value in local store {data:{user:{_id,name,email,role}}}
        name= isAuthenticated().data.user.name; 
         email = isAuthenticated().data.user.email;
         role = isAuthenticated().data.user.role; 

    }else{
        _id=isAuthenticated()._id;
        name=isAuthenticated().name;
        email=isAuthenticated().email;
        role=0;
    }
    const userInfo = () => {
        return (
            <div className="row">
                <div className="col-sm-12 mb-3">
            <div className="card mb-5">
                <h3 className="card-header">Thông tin cá nhân</h3>
                <ul className="list-group">
                    <li className="list-group-item">{name}</li>
                    <li className="list-group-item">{email}</li>
                    <li className="list-group-item">
                        {role === 1 ? "Admin" : "Registered User"}
                    </li>
                </ul>
            </div>
            </div>
            </div>
        );
    };
    const userLinks = () => {
        return (
            
            <div className="card">
                <h4 className="card-header">User Links</h4>
                <ul className="list-group">
                    <li className="list-group-item">
                        <Link className="nav-link" to="/cart">
                            Giỏ hàng
                        </Link>
                    </li>
                    <li className="list-group-item">
                        <Link className="nav-link" to={`/profile/update/${_id}`}>
                            Sửa trang cá nhân
                        </Link>
                    </li>
                    <li className="list-group-item">
                        <Link className="nav-link" to={`/post/create/${_id}`}>
                            Tạo bài viết
                        </Link>
                    </li>
                </ul>
            </div>
           
        );
    };

    // const purchaseHistory =()=>(
    //     <div className="card">
    //         <h4 className="card-header">Lịch sử giao dịch</h4>
    //         <ul className="list-group">
    //                 <li className="list-group-item">
    //                 </li>
    //         </ul>
    //     </div>
    // )

    return (
        <React.Fragment>
            <Layout/>
            <br/>
            <div className="container">

            <div className="row">
                <div className="col-md-3">{userLinks()}</div>
                <div className="col-md-9">
                    {userInfo()}
                    {/* {purchaseHistory()} */}
                </div>
            </div>
            </div>

        </React.Fragment>
    );
}

export default UserDashboard;